<template>
  <div>
    <Navbar v-if="this.$route.name=='consultants'"/>
    <Breadcrumb v-if="this.$route.name=='consultants'" />
    <div v-show="consultant_id == 0 && sendingbulkemail == 0">
      <b-row class="col-12">
        <b-input-group small class="col-8 mr-0 mt-3 mb-3">
          <b-button
            @click.prevent.stop="addconsultant"
            variant="primary"
            class="col-1 gdq_faded gdq-font-size-80"
            ><span class="icon-plus mr-1"></span>Add</b-button
          >
          <b-form-select
            placeholder="Actions"
            v-model="bulkaction"
            class="col-1 ml-2 rounded gdq-font-size-80"
            @change="dobulkaction"
          >
            <option value="0" class="text-muted">Actions</option>
            <option v-show="selectcount != 0" value="1">
              Add label to selected
            </option>
            <option v-show="selectcount != 0" value="2">
              Export selected to Excel
            </option>
            <option v-show="consultants.length > 0" value="4">
              Export ALL in list to Excel
            </option>
            <option value="3">Import from Excel</option>
            <option v-show="selectcount != 0" value="5">
              Send bulk email to selected
            </option>
            <option v-show="consultants.length > 0" value="6">
              Send bulk email ALL in list
            </option>
          </b-form-select>
          <LabelSelect
            @input="consultants_filterget"
            v-model="filterlabel"
            :options="alllabels"
            class="col-2 colrounded mr-4 gdq-font-size-80"
            placeholder="Labels"
          />
          <b-form-select
            @change="consultants_filterget"
            v-model="filterusergroup"
            :options="allusergroups"
            class="col-2 mx-2 rounded gdq-font-size-80"
            placeholder="Roles"
          >
          </b-form-select>
          <b-form-select
            v-model="newsletter"
            @change="consultants_filterget"
            :options="[
              { value: null, text: 'Newsletter all' },
              { value: 1, text: 'Has newsletter' },
              { value: 0, text: 'No newsletter' }
            ]"
            class="col-1 mr-1 pt-1 gdq-font-size-75"
            placeholder="Newsletter"
          >
          </b-form-select>          
          <b-form-select
            @change="consultants_filterget"
            v-model="consultantstatus_id"
            :options="consultantstatuses"
            class="col-2 mr-2 rounded gdq-font-size-80"
            placeholder="Status"
          >
          </b-form-select>
          <b-form-select
            @change="consultants_filterget"
            v-model="consultantgroup_id"
            :options="consultantgroups"
            class="col-2 mr-2 rounded gdq-font-size-80"
            placeholder="Groups"
          >
          </b-form-select>
          <b-form-select
            @change="consultants_filterget"
            v-model="consultantstate"
            class="col-2 rounded gdq-font-size-80"
            placeholder="All roles"
          >
            <option value="0">Active</option>
            <option value="1">Deleted</option>
          </b-form-select>
        </b-input-group>
        <b-input-group small class="col-2 mr-0 mt-3 mb-3">  
          <b-form-input
            v-model="searchId"
            placeholder="Id, Survey ID"
            type="text"
            @input="consultants_filter"
            class="col-12 gdq-font-size-80"
            autocomplete="off"
          >
          </b-form-input>
          <b-input-group-text slot="append">
            <b-btn variant="link" size="sm" @click="search = ''" class="p-0 i">
              X
            </b-btn>
          </b-input-group-text>
        </b-input-group>
        <b-input-group small class="col-2 mr-0 mt-3 mb-3">
          <b-form-input
            v-model="search"
            placeholder="Name/e-mail..."
            type="text"
            @input="consultants_filter"
            class="col-12 gdq-font-size-80"
            autocomplete="off"
          >
          </b-form-input>
          <b-input-group-text slot="append">
            <b-btn variant="link" size="sm" @click="search = ''" class="p-0 i">
              X
            </b-btn>
          </b-input-group-text>          
        </b-input-group>
        Number of consultants in the list: {{ rows }}
      </b-row>

      <b-row>
        <b-input-group
          v-show="bulkaction == 1"
          small
          class="col-2 ml-0 mt-3 mb-3"
        >
          <b-form-input
            v-model="bulkaddinglabeltext"
            placeholder="Label"
            type="text"
            class="col-8"
            autocomplete="off"
          >
          </b-form-input>
          <b-input-group-text
            slot="append"
            :class="bulkaddinglabeltext == '' ? 'bg-danger' : 'bg-success'"
          >
            <b-btn variant="link" size="sm" class="p-0 i">
              <span
                @click.prevent="bulkaddlabel_save"
                style="color: black"
                v-show="bulkaddinglabeltext != ''"
                class="icon-checkmark"
              ></span>
              <span
                @click.prevent="bulkaddlabel_cancel"
                style="color: black"
                v-show="bulkaddinglabeltext == ''"
                class="icon-cross danger"
              ></span>
            </b-btn>
          </b-input-group-text>
        </b-input-group>
        <b-input-group v-show="bulkaction == 2 || bulkaction == 4">
          <b-form-input
            v-model="exportexcelfilename"
            placeholder="Enter Excel file name"
            type="text"
            class="col-3"
            autocomplete="off"
          >
          </b-form-input>
          <b-input-group-text
            slot="append"
            :class="exportexcelfilename == '' ? 'bg-danger' : 'bg-success'"
          >
            <b-btn variant="link" size="sm" class="p-0 i">
              <span
                @click.prevent="exportexcel_save"
                style="color: black"
                v-show="exportexcelfilename != ''"
                class="icon-checkmark"
              ></span>
              <span
                @click.prevent="exportexcel_cancel"
                style="color: black"
                v-show="exportexcelfilename == ''"
                class="icon-cross danger"
              ></span>
            </b-btn>
          </b-input-group-text>
        </b-input-group>
      </b-row>
      <b-alert variant="danger" :show="deleteerror == 1"
        >The consultant cannot be deleted, he/she has open surveys</b-alert
      >
      <b-table
        id="consultants"
        :class="'consultantsTable'"
        hover
        :items="formattedItems"
        :fields="fields"
        :busy="loading"
        :sort-by="orderby"
        :sort-desc="orderdesc"
        @sort-changed="consultants_sort"
        :no-local-sorting="true"
        ref="consultants"
        @row-clicked="editconsultant"
      >
        <template v-slot:head(select)="data">
          <b-form-checkbox
            class="py-0"
            @click.native.stop
            @change="selectall(selected)"
            v-model="selected"
          >
            <span class="text-muted" v-if="selectcount > 0"
              >({{ selectcount }})</span
            >
          </b-form-checkbox>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(select)="data">
          <div class="py-0">
            <b-form-checkbox
              :id="'selected' + data.index"
              v-model="data.item.selected"
              @change="countselected"
            >
            </b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(consultant_name)="data">
          <div :class="`py-0 ${anon ? 'g-anon' : '' }`">
            {{ data.item.consultant_name }}
          </div>
        </template>
        <template v-slot:cell(email)="data">
          <div :class="`py-0 ${anon ? 'g-anon' : '' }`">
            {{ data.item.email }}
          </div>
        </template>
        <template v-slot:cell(labels)="data">
          <div class="form-inline py-0">
            <span
              v-bind:key="label.id"
              v-for="label in data.item.labels"
              :style="{ background: '#' + label.color }"
              class="mr-2 py-0 pl-2 pr-2 rounded"
            >
              {{ label.label }}
              <span
                @click.stop.prevent="removelabel(data.item.id, label.id)"
                class="ml-2"
              >
                <fa-icon name="trash-alt" />
              </span>
            </span>
            <span
              v-show="addinglabel == 0"
              class="icon-plus pt-0 text-secondary"
              :class="data.item.labels.length == 0 ? 'pt-1' : 'pt-0'"
              @click.stop.prevent="addlabel(data.item.id)"
            >
            </span>

            <b-input-group
              v-show="addinglabel == data.item.id"
              small
              class="col-3 pl-0 ml-0 py-0 my-0"
            >
              <b-form-input
                small
                datalist="labellist"
                class="form-control-sm py-0"
                v-model="addinglabeltext"
                placeholder="Add label"
                type="text"
                @keyup.enter.prevent="saveaddlabel"
                @keyup.escape.prevent="addinglabel = 0"
                :ref="'l' + data.item.id"
                autocomplete="off"
              >
              </b-form-input>
              <b-input-group-text class="py-0" slot="append">
                <b-btn
                  variant="link"
                  size="sm"
                  @click="addinglabel = 0"
                  class="p-0 i"
                >
                  X
                </b-btn>
              </b-input-group-text>
              <datalist id="labellist">
                <option :key="label.id" v-for="label in alllabels">
                  {{ label.label }}
                </option>
              </datalist>
            </b-input-group>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <span
            class="mr-2"
            @click.prevent.stop="switchto(data.item.id)"
            style="cursor: zoom-in"
          >
            <fa-icon name="key" />
          </span>
          <span
            v-show="data.item.deleted == 0"
            @click.prevent.stop="
              consultant_delete(data.item.id, data.item.deleted)
            "
          >
            <fa-icon name="trash-alt" />
          </span>
          <span
            v-show="data.item.deleted == 1"
            @click.prevent.stop="
              consultant_delete(data.item.id, data.item.deleted)
            "
            class="icon-checkmark danger mr-4"
          >
          </span>
          <span
            v-show="data.item.deleted == 1"
            @click.prevent.stop="consultant_delete(data.item.id, 2)"
            class="icon-cross danger"
          >
          </span>
        </template>
      </b-table>
      <b-row class="col-12 justify-content-center">
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="consultants"
          @input="consultants_get"
        >
        </b-pagination>
      </b-row>
    </div>
    <div class="col-12" v-if="consultant_id != 0 && sendingbulkemail == 0">
      <Consultant />
    </div>
    <div class="col-12" v-if="sendingbulkemail == 1">
      <BulkMailing :idsArray="idsArray" :emailsArray="emailsArray" @stopsendingemail="handleStopSendingEmail" />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import LabelSelect from "./LabelSelect";
import Consultant from "./Consultant";
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import { config } from "../../config";
import BulkMailing from "./BulkMailing.vue";

const fields = [
  { key: "select", label: "", sortable: false },
  { key: "id", label: "ID", sortable: true },
  { key: "consultant_name", label: "Name", sortable: true, tdClass: "col-2 gdq-w-15" },
  { key: "email", label: "E-mail", sortable: true },
  { key: "consultantstatus_name", label: "Status", sortable: false },
  { key: "certificate_number", label: "GDQ#", sortable: true, tdClass: "col-1 gdq-w-5" },
  { key: "certification_date", label: "Cert.date", sortable: true, tdClass: "col-1 gdq-w-10" },
  { key: "partner_name", label: "Partner", sortable: false },
  { key: "groupcount", label: "Groups", sortable: false },
  { key: "labels", label: "Labels", sortable: false, tdClass: "col-5" },
  { key: "actions", label: "", sortable: false, tdClass: "col-1 gdq-w-10" },
];
export default {
  components: {
    Consultant,
    LabelSelect,
    Navbar,
    Breadcrumb,
    BulkMailing
  },
  name: "Consultants",
  mounted() {
    this.consultantstatuses_get();
    this.consultantgroups_get();
    this.labels_get();
    this.usergroups_get();
    this.filterlabel = 0;
    this.consultants_get();
    this.emailtemplates_get();
  },
  data: function () {
    return {
      deleteerror: 0,
      search: "",
      searchId: null,
      searching: false,
      searchcalc: false,
      bulkaddinglabel: 0,
      bulkaddinglabeltext: "",
      exportexcelfilename: "",
      fields: fields,
      consultants: [],
      allconsultants: [],
      allowmultiselect: false,
      muteclass: "text-muted",
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
      orderby: "id",
      orderdesc: false,
      selected: 0,
      addinglabel: 0,
      addinglabeltext: "",
      filterlabel: 0,
      alllabels: [],
      filterusergroup: 0,
      allusergroups: [],
      consultantstate: 0,
      consultantstatus_id: 0,
      consultantgroup_id: 0,
      consultantstatuses: [],
      consultantgroups: [],
      bulkaction: 0,
      selectcount: 0,
      emailtemplate: 0,
      emailtemplates: [],
      newsletter: null,
      sendingbulkemail: 0,
      idsArray: [],
      emailsArray: [],
    };
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
    consultant_id: {
      get() {
        return this.$store.state.currentconsultant_id;
      },
    },
    consultantlabelchanged: {
      get() {
        return this.$store.state.consultantlabelchanged;
      },
    },
    formattedItems () {
      if (!this.consultants) return []
      return this.consultants.map(item => {
        item._rowVariant  = this.getVariant(item.consultantstatus_name)
        return item
      })
    }
  },
  watch: {
    search: function () {
      this.searching = true;
      this.consultants_filter();
    },
    consultantchanged: function () {
      if (this.$store.state.consultantchanged != 0) {
        this.consultant_get(this.$store.state.consultantchanged).then(() => {
          this.$store.dispatch("consultantchanged_set", { consultant_id: 0 });
        });
      }
    },
    consultantlabelchanged: function () {
      if (this.$store.state.consultantlabelchanged != 0) {
        this.conlabels_get(this.$store.state.consultantlabelchanged);
        this.$store.dispatch("consultantlabelchanged_set", {
          consultant_id: 0,
        });
      }
    },
    consultant_id: function () {
      this.consultants_filterget();
    },
  },
  methods: {
    handleStopSendingEmail() {
      this.sendingbulkemail = false;
    },
    emailtemplates_get() {
      this.$store.dispatch("records_readall", { table_name: 'g_bulkemailtemplates'}).then((resp) => {
        this.emailtemplates = resp.data.result;
      });
    },
    getVariant(status) {
      if (status === 'Under Certification') { return 'warning' }
      if (status === 'Blocked') { return 'danger' }
      return '';
    },
    switchto(id) {
      this.$store
        .dispatch("switchto", { i_name: "", i_password: "", user_id: id })
        .then((resp) => {
          window.open(config.web_url + "/?t=" + resp, "GDQSwitchTo");
        });
    },
    dobulkaction() {
      if (this.bulkaction == 3) {
        this.$router.push("/importconsultants");
        //this.$router.push('/profile');
      }
      if (this.bulkaction == 5) {
        this.bulkemailingstart()
      }
      if (this.bulkaction == 6) {
        this.bulkemailingstart()
      }
    },
    consultant_delete(id, deleted) {
      if (deleted != 2) {
        var newflag = 1 - deleted;
      } else {
        newflag = deleted;
      }
      var data = {
        id: id,
        deleted: newflag,
      };
      this.$store.dispatch("consultant_flagdelete", data).then((resp) => {
        if (resp.data.id == 0) {
          this.deleteerror = 1;
        } else {
          this.deleteerror = 0;
          this.consultants_get();
        }
        return false;
      });
    },
    bulkaddlabel_save() {
      var ids = [];
      for (var i = 0; i < this.consultants.length; i++) {
        if (this.consultants[i].selected) {
          ids.push(this.consultants[i].id);
        }
      }
      var data = {
        ids: ids,
        label: this.bulkaddinglabeltext,
      };
      this.$store.dispatch("consultantlabels_bulkadd", data).then(() => {
        this.bulkaction = 0;
        this.consultants_get();
      });
    },
    bulkaddlabel_cancel() {
      this.bulkaction = 0;
      this.bulkaddinglabeltext = "";
    },
    async exportexcel_save() {
      if (this.bulkaction == 4) {
        await this.consultants_getallfiltered().then(() => {
          var ids = [];
          for (var i = 0; i < this.allconsultants.length; i++) {
            ids.push(this.allconsultants[i].id);
          }
          this.$store
            .dispatch("consultants_exportexcel", { ids: ids })
            .then((resp) => {
              var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              var filename = this.exportexcelfilename;
              fileLink.setAttribute("download", filename + ".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              this.bulkaction = 0;
            });
        });
      } else {
        var ids = [];
        for (var i = 0; i < this.consultants.length; i++) {
          if (this.consultants[i].selected) {
            ids.push(this.consultants[i].id);
          }
        }
        var data = {
          ids: ids,
        };
        this.$store.dispatch("consultants_exportexcel", data).then((resp) => {
          var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          var filename = this.exportexcelfilename;
          fileLink.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.bulkaction = 0;
        });
      }
    },
    async bulkemailingstart() {
      let ids = [];
      let emails = [];
      if (this.bulkaction == 6) {
        await this.consultants_getallfiltered().then(() => {
          for (var i = 0; i < this.allconsultants.length; i++) {
            ids.push(this.allconsultants[i].id);
            emails.push(this.allconsultants[i].email);
          }
        });
      } else {
        for (var i = 0; i < this.consultants.length; i++) {
          if (this.consultants[i].selected) {
            ids.push(this.consultants[i].id);
            emails.push(this.consultants[i].email);
          }
        }
      }
      this.idsArray = ids;
      this.emailsArray = emails;
      this.sendingbulkemail = true;      
    },
    exportexcel_cancel() {
      this.bulkaction = 0;
      this.exportexcelfilename = "";
    },
    addconsultant() {
      this.$store.dispatch("consultant_setcurrent", { consultant_id: -1 });
    },
    editconsultant(item) {
      this.$store.dispatch("consultant_setcurrent", { consultant_id: item.id });
    },
    saveaddlabel() {
      if (this.addinglabeltext != "") {
        var savelabel = {
          consultant_id: this.addinglabel,
          label: this.addinglabeltext,
        };
        this.$store
          .dispatch("consultantlabel_add", { label: savelabel })
          .then(() => {
            this.labels_get();
            this.conlabels_get(this.addinglabel);
            this.addinglabel = 0;
            this.addinglabeltext = "";
          });
      }
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = "";
      this.$nextTick(() => this.$refs["l" + id].focus());
    },
    removelabel(consultant_id, consultantlabel_id) {
      this.$store
        .dispatch("consultantlabel_delete", { id: consultantlabel_id })
        .then(() => {
          this.labels_get();
          this.conlabels_get(consultant_id);
        });
    },
    consultant_get(consultant_id) {
      var first_name = "";
      var family_name = "";
      var email = "";
      this.$store
        .dispatch("consultant_fetch", { consultant_id: consultant_id })
        .then((resp) => {
          first_name = resp.data.first_name;
          family_name = resp.data.family_name;
          email = resp.data.email;
          for (var i = 0; i < this.consultants.length; i++) {
            if (this.consultants[i].id == consultant_id) {
              this.consultants[i].consultant_name =
                family_name + ", " + first_name;
              this.consultants[i].email = email;
            }
          }
          this.$store
            .dispatch("consultant_setcurrent", { consultant_id: consultant_id })
            .then(() => {
              return true;
            });
        });
    },
    conlabels_get(consultant_id) {
      this.$store
        .dispatch("consultantlabels_fetch", { consultant_id: consultant_id })
        .then((resp) => {
          for (var i = 0; i < this.consultants.length; i++) {
            if (this.consultants[i].id == consultant_id) {
              this.consultants[i].labels = resp.data;
            }
          }
        });
    },
    selectall(selected) {
      var setselectto = !selected;
      for (var i = 0; i < this.consultants.length; i++) {
        this.consultants[i].selected = setselectto;
      }
      this.countselected();
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i = 0; i < this.consultants.length; i++) {
          if (this.consultants[i].selected) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      });
    },
    consultants_filter: _.debounce(function () {
      this.searchcalc = true;
      setTimeout(
        function () {
          this.consultants_filterget();
          this.searchcalc = false;
          this.searching = false;
        }.bind(this),
        500
      );
    }, 300),
    consultants_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.consultants_filterget();
    },
    consultants_filterget() {
      this.currentPage = 1;
      this.consultants_get();
    },
    consultants_get() {
      this.loading = true;
      let filter = {};
      if (this.search != "") {
        filter.family_name = {
            operator: "LIKE",
            value: "%" + this.search + "%",
        };
        filter.first_name = {
            operator: "LIKE",
            value: "%" + this.search + "%",
        };
        filter.email =  {
          operator: "LIKE",
          value: "%" + this.search + "%",
        };
      }
      if (this.searchId && this.searchId != "" && parseInt(this.searchId) && parseInt(this.seachId) != 0) {
        filter.id = {
          operator: "=",
          value: this.searchId,
        }
        filter.survey_id = {
          operator: "=",
          value: this.searchId,          
        }
      }
      const params = {
          start: this.currentPage,
          limit: this.perPage,
          orderby: this.orderby,
          order: this.orderdesc == false ? "ASC" : "DESC",
          filter: filter,
          label_id: this.filterlabel?this.filterlabel:0,
          usergroup_id: this.filterusergroup,
          consultantstatus_id: this.consultantstatus_id,
          consultantgroup_id: this.consultantgroup_id,
          deleted: this.consultantstate,
          ...(this.newsletter !== null && { newsletter: this.newsletter ? 1 : 0 }),
      }
      this.$store
        .dispatch("consultants_fetch", params)
        .then((resp) => {
          this.consultants = [];
          for (var i = 0; i < resp.data.result.length; i++) {
            var labels = resp.data.result[i].labels;
            var result = {
              id: resp.data.result[i].id,
              selected: false,
              consultantstatus_name: resp.data.result[i].consultantstatus_name,
              certificate_number: resp.data.result[i].certificate_number,
              certification_date: resp.data.result[i].certification_date,
              consultant_name: resp.data.result[i].consultant_name,
              partner_name: resp.data.result[i].partner_name,
              email: resp.data.result[i].email,
              labels: labels,
              deleted: resp.data.result[i].deleted,
              groupcount: resp.data.result[i].groupcount,
            };
            this.consultants.push(result);
          }
          this.rows = resp.data.total;
          this.loading = false;
        });
    },
    async consultants_getallfiltered() {
      this.loading = true;
      var filter = "";
      if (this.search != "") {
        filter = {
          family_name: {
            operator: "LIKE",
            value: "%" + this.search + "%",
          },
          first_name: {
            operator: "LIKE",
            value: "%" + this.search + "%",
          },
          email: {
            operator: "LIKE",
            value: "%" + this.search + "%",
          },
        };
      }
      return this.$store
        .dispatch("consultants_fetch", {
          start: 1,
          limit: 100000,
          orderby: this.orderby,
          order: this.orderdesc == false ? "ASC" : "DESC",
          filter: filter,
          label_id: this.filterlabel?this.filterlabel:0,
          usergroup_id: this.filterusergroup,
          consultantstatus_id: this.consultantstatus_id,
          deleted: this.consultantstate,
          ...(this.newsletter !== null && { newsletter: this.newsletter ? 1 : 0 }),
        })
        .then((resp) => {
          this.allconsultants = [];
          for (var i = 0; i < resp.data.result.length; i++) {
            var labels = resp.data.result[i].labels;
            var result = {
              id: resp.data.result[i].id,
              selected: false,
              consultantstatus_name: resp.data.result[i].consultantstatus_name,
              consultant_name: resp.data.result[i].consultant_name,
              partner_name: resp.data.result[i].partner_name,
              email: resp.data.result[i].email,
              labels: labels,
              deleted: resp.data.result[i].deleted,
              groupcount: resp.data.result[i].groupcount,
            };
            this.allconsultants.push(result);
          }
          this.rows = resp.data.total;
          this.loading = false;
        });
    },
    labels_get() {
      this.$store.dispatch("labels_fetch").then((resp) => {
        var dblabels = resp.data.result;
        var labels = [];
        for (var i = 0; i < dblabels.length; i++) {
          var option = {
            value: dblabels[i].id,
            text: dblabels[i].label,
            color: dblabels[i].color,
          };
          labels.push(option);
        }
        labels.unshift({ value: 0, text: "Labels", color: "ffffff" });
        this.alllabels = labels;
      });
    },
    usergroups_get() {
      var usergroups = [];
      usergroups.push({ value: 0, text: "Roles" });
      for (var i = 0; i < this.$store.state.usergroups.length; i++) {
        var usergroup = {
          value: this.$store.state.usergroups[i].id,
          text: this.$store.state.usergroups[i].name,
        };
        usergroups.push(usergroup);
      }
      this.allusergroups = usergroups;
    },
    consultantstatuses_get() {
      this.$store
        .dispatch("consultantstatuses_fetch", {
          filter: {
            consultantstatus_name: {
              operator: "<>",
              value: "",
            },
          },
          start: 1,
          limit: 999999,
          orderby: "id",
          order: "ASC",
        })
        .then((resp) => {
          this.consultantstatuses = [];
          this.consultantstatuses.push({ value: 0, text: "Status" });
          for (var i = 0; i < resp.data.result.length; i++) {
            var consultantstatus = {
              value: resp.data.result[i].id,
              text: resp.data.result[i].consultantstatus_name,
            };
            this.consultantstatuses.push(consultantstatus);
          }
        });
    },
    consultantgroups_get() {
      this.$store.dispatch('records_readlist',{ table_name: 'g_consultantgroups' })
      .then((resp) => {
        let consultantgroups = resp.data.result.map( r => ({ value: r.id, text: r.consultantgroup_name }));
        consultantgroups.unshift({ value: 0, text: 'Groups'});
        this.consultantgroups = consultantgroups;
      });
    },    
  },
};
</script>
<style>
.gdq-faded {
  opacity: 0.5;
}
.headselect {
  color: red;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 30px;
  position: absolute;
  top: 20px;
}
.consultantsTable {
  font-size: 0.9rem !important;
}
</style>
